import { useQuery } from "@apollo/client";
// import { Button } from "@aqar-app/aqar-design-system";
import Head from "next/head";
import { useState } from "react";
import Link from "next/link";
import css from "./.module.scss";
import { LICENSING_BY_QAR } from "../../graphql/queries/info";
import Skeleton from "../../components/skeleton";
import {
  dehydrateApolloClient,
  initApolloClient,
} from "../../lib/apolloClient";
import { InitialResolver } from "../../lib/use.middlewares";
import { Button } from "@aqar-app/react-ui";
import {
  trackContinueServiceOption,
  trackSubscribeFromServiceOption,
} from "@/lib/tracking/trackAddServiceOptions";
import withAuthentication from "@/hoc/withAuthentication";

const LicensingByAqar = withAuthentication(function LicensingByAqar() {
  const [screenData, setScreenData] = useState({});
  const { loading } = useQuery(LICENSING_BY_QAR, {
    onCompleted: (data) => {
      setScreenData(data?.Info.configurations?.licensing_by_aqar_ar || {});
    },
  });

  if (loading)
    return (
      <Skeleton className={css.aqar}>
        <Head>
          <title>اضافة اعلان</title>
        </Head>
        <Skeleton.Text className="" style={{ width: "8em", height: "1.1em" }} />

        <div className={css.card}>
          <Skeleton.Item
            className=""
            circle
            style={{ width: "8rem", height: "8rem" }}
          />

          <Skeleton.Text
            className=""
            style={{ width: "8em", height: "1.1em" }}
          />

          <div className={css.section}>
            <Skeleton.Text
              className=""
              style={{ width: "8em", height: ".8em" }}
            />

            <ul>
              <li>
                <Skeleton.Text
                  className=""
                  style={{ width: "8em", height: ".5em" }}
                />
              </li>
              <li>
                <Skeleton.Text
                  className=""
                  style={{ width: "8em", height: ".5em" }}
                />
              </li>
              <li>
                <Skeleton.Text
                  className=""
                  style={{ width: "8em", height: ".5em" }}
                />
              </li>
            </ul>
          </div>

          <table>
            <thead>
              <tr>
                <th>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </th>
                <th>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </th>

                <th>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </td>
                <td>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </td>
                <td>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </td>
                <td>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </td>
                <td>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </td>
                <td>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </td>
                <td>
                  <Skeleton.Text
                    className=""
                    style={{ width: "8em", height: ".5em" }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <Button priority="primary">
            <Skeleton.Text
              className=""
              style={{ width: "8em", height: ".5em" }}
            />
          </Button>
          <p className={css.note}>
            <Skeleton.Text
              className=""
              style={{ width: "15em", height: ".5em" }}
            />
          </p>
        </div>

        <div className={css.sub}>
          <p>
            <Skeleton.Text
              className=""
              style={{ width: "8em", height: ".5em" }}
            />
          </p>
          <Button priority="tertiary">
            <Skeleton.Text
              className=""
              style={{ width: "8em", height: ".5em" }}
            />
          </Button>
        </div>
      </Skeleton>
    );

  return (
    <div className={css.aqar}>
      <Head>
        <title>{screenData.title || "اضافة اعلان"}</title>
      </Head>
      <h3>{screenData.title}</h3>

      <div className={css.card}>
        <img alt={screenData.image} src={screenData.image} width={150} />
        <p>{screenData.subtitle}</p>

        {screenData?.sections?.map((section) => (
          <div key={section.title} className={css.section}>
            <p>{section.title}</p>
            <ul>
              {section?.bullets?.map((bl) => (
                <li key={bl}>{bl}</li>
              ))}
            </ul>
          </div>
        ))}

        <table>
          <thead>
            <tr>
              {screenData?.table?.headers?.map((header) => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {screenData?.table?.rows?.map((row) => (
              <tr>
                {row.map((cell) => (
                  <td key={cell}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <Link
          href="/add-listing/check-deed"
          onClick={(e) => {
            e.preventDefault();
            trackContinueServiceOption();
            window.location.href = "/add-listing/check-deed";
          }}
        >
          <Button theme="primary">{screenData?.continue_button_text}</Button>
        </Link>
        {screenData?.notes?.map((note) => (
          <p key={note} className={css.note}>
            {note}
          </p>
        ))}
      </div>

      {screenData?.subscription_button?.show_button && (
        <div className={css.sub}>
          {screenData?.subscription_button?.note}
          <Link
            href="/payment-gateway/pricing-packages"
            onClick={trackSubscribeFromServiceOption}
          >
            {screenData?.subscription_button?.text}
          </Link>
        </div>
      )}
    </div>
  );
});

LicensingByAqar.getInitialProps = InitialResolver(async () => {
  const apolloClient = initApolloClient();
  const { data } = await apolloClient.query({
    query: LICENSING_BY_QAR,
  });
  const { configurations } = data?.Info || {};
  return dehydrateApolloClient(apolloClient, {
    configurations,
  });
});

export default LicensingByAqar;
